<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary"
          @click="$router.push('/locations/create')"
        >
          <i class="fa fa-plus"></i> Hinzufügen
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th class="text-center">Produkte</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="location in locations" :key="location.id">
                <td v-text="location.name"></td>
                <td class="text-center">
                  <a v-tooltip.top-center="'Produkte'" class="btn btn-info btn-link btn-xs"
                    @click="$router.push(`/locations/${location.id}/products`)"
                  >
                  <i class="fas fa-boxes" aria-hidden="true"></i>
                  </a>
                </td>
                <td class="text-right">
                  <div class="td-actions">
                    <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                       @click="editLocation(location)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                       @click="deleteLocation(location)">
                      <i class="fa fa-close"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      locations: []
    }
  },
  methods: {
    editLocation (location) {
      this.$router.push(`/locations/${location.id}/edit`)
    },
    async deleteLocation (location) {
      if (confirm(`Standort ${location.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/locations/${location.id}`).then(({ data }) => {
          this.$notify({
            message: `Standort ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.locations.findIndex(({ id }) => data.id === id)
          this.locations.splice(index, 1)
        })
      }
    },
    async updateOrder () {
      await this.initCsrf()

      const locations = this.locations.reduce((locations, location, idx) => ({ ...locations, [location.id]: idx }), {})
      this.$http.put(`/locations`, { locations })
    }
  },
  created () {
    this.$http.get('/locations').then(({ data }) => { this.locations = data })
  }
}
</script>
